import commonStyles from '../styles.module.scss'
import {ButtonLink, Modal} from 'common/components'
import {useOpen} from 'common/hooks'
import {PushBackForm} from '..'

interface RequestPushBackProps {
  requestUuid: string
  disabled?: boolean
}

export default function RequestPushBack({
  requestUuid,
  disabled,
}: RequestPushBackProps) {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <div className={commonStyles.declineContent}>
        <ButtonLink
          danger
          className={commonStyles.declineButton}
          disabled={disabled}
          onClick={handleOpen}
        >
          push back
        </ButtonLink>{' '}
        to Lending manager
      </div>
      <Modal
        width={486}
        title="Back to Lending Manager"
        open={isOpen}
        onCancel={handleClose}
      >
        <PushBackForm requestUuid={requestUuid} onClose={handleClose} />
      </Modal>
    </>
  )
}
